import { render, staticRenderFns } from "./AccessUsers.vue?vue&type=template&id=3d977d9c"
import script from "./AccessUsers.vue?vue&type=script&lang=js"
export * from "./AccessUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports